export default function isNumericString(string) {
  return typeof string === 'string' && !isNaN(string - parseFloat(string));
}
